import type { ActivationTask } from '@cobliteam/api-lib/src/__generated__/graphql';
import { Location } from '@cobliteam/common-types';
import { ActivationTasksTypes, type Category } from '../ActivationTasksCommon';
import alertsImage from '../assets/alerts-activation-task.png';
import checklistImage from '../assets/checklist-activation-task.png';
import geofencesImage from '../assets/geofences-activation-task.png';

export const getOngoingTaskConfiguration = (activationTasks: ActivationTask[]) => {
  const checklistCategory: Category = {
    i18nKey: 'create_checklists',
    image: checklistImage,
    tasks: [
      {
        i18nKey: 'create_checklists',
        url: Location.CHECKLIST,
        name: ActivationTasksTypes.CREATE_CHECKLISTS,
        permissions: ['full-control:checklist'],
        id: activationTasks.find((activationTask) => activationTask.name === ActivationTasksTypes.CREATE_CHECKLISTS)?.id ?? '',
      },
    ],
  };

  const placesOfInterestCategory: Category = {
    i18nKey: 'create_geofences',
    image: geofencesImage,
    tasks: [
      {
        i18nKey: 'create_geofences',
        url: Location.GEOFENCES,
        name: ActivationTasksTypes.CREATE_GEOFENCES,
        permissions: ['create-update-delete:places-of-interest'],
        id: activationTasks.find((activationTask) => activationTask.name === ActivationTasksTypes.CREATE_GEOFENCES)?.id ?? '',
      },
    ],
  };

  const alertsAndNotificationsCategory: Category = {
    i18nKey: 'configure_alerts',
    image: alertsImage,
    tasks: [
      {
        i18nKey: 'configure_alerts',
        url: Location.ALERTS_TRIGGERS,
        name: ActivationTasksTypes.CONFIGURE_ALERTS,
        permissions: ['config-and-view:custom-alerts'],
        id: activationTasks.find((activationTask) => activationTask.name === ActivationTasksTypes.CONFIGURE_ALERTS)?.id ?? '',
      },
    ],
  };

  return [checklistCategory, placesOfInterestCategory, alertsAndNotificationsCategory];
};
